var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionStarNon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8906 27.4856L8.59926 31.8438C7.62131 32.3581 6.47947 31.528 6.666 30.4395L8.24885 21.2075C8.32346 20.7759 8.17957 20.3348 7.86513 20.0284L1.15802 13.4905C0.366592 12.7191 0.803607 11.376 1.89614 11.2175L11.1654 9.87048C11.5997 9.80785 11.9741 9.53472 12.1687 9.14167L16.3136 0.742459C16.8026 -0.247486 18.2149 -0.247486 18.7026 0.742459L22.8475 9.14167C23.0421 9.53472 23.4165 9.80785 23.8508 9.87048L33.1201 11.2175C34.2126 11.376 34.6496 12.7191 33.8582 13.4905L27.1511 20.0284C26.8366 20.3348 26.6941 20.7759 26.7674 21.2075L28.3502 30.4395C28.5367 31.528 27.3949 32.3581 26.4169 31.8438L18.1257 27.4856C17.7379 27.2818 17.2743 27.2818 16.8852 27.4856H16.8906Z",
    fill: "#C9C9C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionStarNon);
export default __webpack_public_path__ + "static/media/question-star-non.df15328506f23376c5245e51076aa676.svg";
export { ForwardRef as ReactComponent };